import { DashboardCard } from "../../dashboard-card";

export function TicketsContent() {
  const mockTickets = [
    {
      id: 1,
      status: "secondary" as const,
      statusLabel: "In Progress",
      title: "Insurance verification needed",
      assignees: [
        {
          src: "https://github.com/shadcn.png",
          alt: "Dr. Smith",
          name: "Dr. Sarah Smith",
        },
        {
          src: "https://github.com/shadcn.png",
          alt: "Nurse Johnson",
          name: "Nurse Jennifer Johnson",
        },
      ],
      description: "Patient insurance information requires verification before next appointment",
      dueDate: "Today",
      priority: "Medium priority",
      timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago
    },
    {
      id: 2,
      status: "secondary" as const,
      statusLabel: "In Progress",
      title: "Lab results follow-up",
      assignees: [
        {
          src: "https://github.com/shadcn.png",
          alt: "Lab Tech",
          name: "Alex Johnson",
        },
      ],
      description: "Review and discuss recent blood work results with patient",
      dueDate: "Tomorrow",
      priority: "Medium priority",
      timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000), // 4 hours ago
    },
    {
      id: 3,
      status: "default" as const,
      statusLabel: "Open",
      title: "Prescription refill request",
      assignees: [
        {
          src: "https://github.com/shadcn.png",
          alt: "Pharmacist",
          name: "Dr. Mike Pharmacist",
        },
        {
          src: "https://github.com/shadcn.png",
          alt: "Dr. Wilson",
          name: "Dr. Michael Wilson",
        },
      ],
      description: "Patient requesting refill for blood pressure medication",
      dueDate: "In 3 days",
      priority: "Low priority",
      timestamp: new Date(Date.now() - 6 * 60 * 60 * 1000), // 6 hours ago
    },
    {
      id: 4,
      status: "outline" as const,
      statusLabel: "Waiting",
      title: "Appointment rescheduling",
      assignees: null,
      description: "Patient needs to reschedule upcoming consultation due to conflict",
      dueDate: "This week",
      priority: "Low priority",
      timestamp: new Date(Date.now() - 8 * 60 * 60 * 1000), // 8 hours ago
    },
    {
      id: 5,
      status: "secondary" as const,
      statusLabel: "In Progress",
      title: "Medical records request",
      assignees: [
        {
          src: "https://github.com/shadcn.png",
          alt: "Records Admin",
          name: "Emily Records Admin",
        },
      ],
      description: "Transfer medical records to new specialist for consultation",
      dueDate: "Next week",
      priority: "Medium priority",
      timestamp: new Date(Date.now() - 12 * 60 * 60 * 1000), // 12 hours ago
    },
  ];

  return (
    <div className="flex-1 overflow-y-auto space-y-4 pr-2">
      {mockTickets.map((ticket) => (
        <DashboardCard
          key={ticket.id}
          status={ticket.status}
          statusLabel={ticket.statusLabel}
          title={ticket.title}
          assignees={ticket.assignees}
          description={ticket.description}
          dueDate={ticket.dueDate}
          priority={ticket.priority}
          timestamp={ticket.timestamp}
          className="w-full"
        />
      ))}
    </div>
  );
}
